import React from 'react'
import ReactDOM from 'react-dom'
import PostEditor from './PostEditor'

const PostV3 = {
  init() {
    const props = this.el.dataset.reactProps ? this.el.dataset.reactProps : '{}'
    const propsJSON = JSON.parse(props)
    const liveview = { id: this.el.getAttribute('id'), phxLV: this, phxTarget: this.el.dataset.reactPhxTarget }
    const element = React.createElement(PostEditor, { ...propsJSON, ...liveview })

    ReactDOM.render(element, this.el)
  },
  mounted() {
    this.init()
  },
  updated() {
    this.init()
  },
}

export default PostV3
